import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { ListItem, Checkbox } from 'material-ui';
import GenericTableRow from '../generic-table-row';
import { contains, ifElse, equals, modulo, __, call, always, lt } from 'ramda';

const CompanyTypeTable = props => {
  const {
    companyTypeChecked,
    checkOneCompanyType,
    uncheckOneCompanyType,
    selectedCompanyType,
    companyType,
    coloredIcon,
    icon,
    desc,
    checkBoxItems,
    dispatchedUpdateProps,
    signup,
  } = props;

  return (
    <GenericTableRow
      rowId={`row${companyType}`}
      leftIcon={<img src={equals(selectedCompanyType, companyType) ? coloredIcon : icon} />}
      leftIconStyle={{ border: '1px solid #eeeeee', width: '23%', height: '68px', textAlign: 'center' }}
      companyType={companyType}
      middleInfo={<ListItem
        primaryText={desc}
        primaryTogglesNestedList
        nestedItems={checkBoxItems.map((box, i) => {
          return (
            <Checkbox
              id={`companyDoCheckbox-${i}`}
              key={i}
              label={box}
              onCheck={ifElse(
                () => contains(box, companyTypeChecked),
                  () => uncheckOneCompanyType(box),
                () => {
                  checkOneCompanyType({ [companyType]: box });
                  dispatchedUpdateProps({
                    MMCompanyToView: signup.MMCompanyToView,
                    email: signup.email,
                  });
                }
              )}
              checked={contains(box, companyTypeChecked)}
              style={{ float: 'left', width: checkBoxItems.length > 6 ? '50%' : '100%' }}
              className="company-type-checkboxes"
            />
          );
        })}
      />}
      middleInfoStyle={{ fontSize: '16px', border: '1px solid #eeeeee', whiteSpace: 'break-word', height: '68px' }}
      thirdColumn={false}
    />
  );
};

CompanyTypeTable.propTypes = {
  checkOneCompanyType: PropTypes.func,
  uncheckOneCompanyType: PropTypes.func,
  companyTypeChecked: PropTypes.array,
  selectedCompanyType: PropTypes.string,
  companyType: PropTypes.string,
  coloredIcon: PropTypes.string,
  icon: PropTypes.string,
  desc: PropTypes.string,
  checkBoxItems: PropTypes.array,
  dispatchedUpdateProps: PropTypes.func,
  signup: PropTypes.object,
};

const mapStateToProps = state => ({
  signup: state.signup.toJS(),
});

export default connect(mapStateToProps)(CompanyTypeTable);



// WEBPACK FOOTER //
// ./src/app/components/signup/select-company-type/company-type-table.jsx